<div class="caremoni-checkbox tt-setting" (click)="handleClick($event)"
    [ngClass]="{ 'caremoni-checkbox-checked': value, 'disabled-style': disabled }" 
    [ngStyle]="style"
    [attr.dpad]="dpad"
    [style.--scale-dpad]="scaledpad"
    [attr.x-dpad]="xdpad" 
    [attr.y-dpad]="ydpad" 
    [attr.tab-dpad]="tabdpad"
    [attr.x-tab-dpad]="xtabdpad" 
    [attr.y-tab-dpad]="ytabdpad" 
>
    <img id='checkbox-check' class="icon-checked" *ngIf="value" [ngStyle]="iconStyle" />
</div>